// Centralized place to keep feature flag variables for hiding in-progress features

// Define the variable here so it can be used througout the app
// Keep the flag in place and change it to 'active' in Azure when ready to release it in prod (makes rollbacks easy)
// Once the feature is working in prod, refactor the code and delete the feature flag

// Working with environment variables:
// Set the value of the var to 'active' or 'inactive' (booleans do not work, they are parsed as strings, so any string is truthy)
// Env vars are inserted during the build, so updating the var in the .env file will not take effect immediately with hot module reloading (HMR). You will need to to run 'gatsby clean' then, 'gatsby develop' to get the new value in the code.
// To take advantage of HMR just set the value directly in this file while developing.

const featureFlags = {
  strategyBuilder: process.env.GATSBY_FEATURE_FLAGS_STRATEGY_BUILDER,
  commonwealthServices: process.env.GATSBY_FEATURE_FLAGS_COMMONWEALTH_SERVICES,
  recommendResources: process.env.GATSBY_FEATURE_FLAGS_RECOMMEND_RESOURCES,
  peerStories: process.env.GATSBY_FEATURE_FLAGS_PEER_STORIES,
  learningCenter: process.env.GATSBY_FEATURE_FLAGS_LEARNING_CENTER,
  maintenancePackage: process.env.GATSBY_FEATURE_FLAGS_MAINTENANCE_PACKAGE,
  easysiteRequestForm: process.env.GATSBY_FEATURE_FLAGS_EASYSITE_REQUEST_FORM,
  servicePackageDocusign:
    process.env.GATSBY_FEATURE_FLAGS_SERVICE_PACKAGE_DOCUSIGN,
  sbRecommendedResources:
    process.env.GATSBY_FEATURE_FLAGS_SB_RECOMMENDED_RESOURCES,
  websiteServicesRedesign:
    process.env.GATSBY_FEATURE_FLAGS_WEBSITE_SERVICES_REDESIGN,
}

export default featureFlags
